import React, {useEffect, useState} from "react";
import PropTypes from 'prop-types';
import Item from 'components/Home/JumboWorld/Item';
import CMSFactory from "factories/CMS";
import style from './style.scss'; //NOSONAR

const JumboWorld = (props) => {
    const [item, setItem] = useState(null);

    const getItem = (categoryJw) => {
        let countItem = 0 ;
        let serverDate = (props.item && props.item.serverDate) ? props.item.serverDate : new Date().getTime();

        let cat = categoryJw.map((itemCat, i) => {
            if (countItem > 3) return false;

            let startDate = itemCat.start_date ? CMSFactory.milliseconds(itemCat.start_date) : '';
            let endDate = itemCat.end_date ? CMSFactory.milliseconds(itemCat.end_date) : '';

            if (startDate && (startDate >= serverDate)) return false;
            if (endDate && (serverDate >= endDate)) return false;
            if (!itemCat.active) return false;

            if (typeof window !== 'undefined' && window.innerWidth <= 768) {
                itemCat.id = itemCat.image_mobile.url  ? itemCat.image_mobile.url.split('/').pop() : '';
            } else {
                itemCat.id = itemCat.image_desktop.url  ? itemCat.image_desktop.url.split('/').pop() : '';
            }

            countItem++;
            itemCat.typePromotion = 'Recomendados';
            let position = 'slot' + (countItem);
            let gtmData = {
                id: itemCat.id,
                name: itemCat.title,
                creative: itemCat.typePromotion,
                position: position,
                type: 'jumboWorld'
            };

            return (<Item item={itemCat} key={i} position={position} title={itemCat.typePromotion} gtmData={gtmData}/>)
        }).filter(Boolean);

        return cat;
    };

    const category = props.item && props.item.category ? props.item.category : [];
    let title = props.item && props.item.title ? props.item.title : '';

    useEffect(() => {
        setItem(getItem(category));
    }, []);

    if(item && item.length !== 4) return '';

    return (
        <section className="jumbo-world-container">
            <h1 className="jumbo-world-title">{title}</h1>
            <div className="jumbo-world-container-wrap">
                {item}
            </div>
        </section>
    )
};

JumboWorld.propTypes = {
    item: PropTypes.object
};

export default JumboWorld;
